import React from 'react';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
const ProviderGameCommingSoon = (props) => {
    return (
        <div className='popup-box'>
            <h4 className="title">{props.t('attention')} !</h4>
            <p>{props.t('comming_soon')} ...</p>
        </div>
    )
}

ProviderGameCommingSoon.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(ProviderGameCommingSoon);